module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_moere_og_romsdal_neg.d2b4f4c8.pdf";